// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.start-mining {
  max-width: 900px;
  margin: 60px auto 100px;
  padding: 40px 30px;
  background-color: #0d0d0d;
  color: #f2f2f2;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  font-size: 1.1rem;
  box-shadow: 0 4px 15px rgba(247, 147, 26, 0.8);
  border-radius: 8px;
  text-align: center;
}

.start-mining h2 {
  color: #f7931a;
  margin-bottom: 30px;
  font-weight: 600;
}

.dashboard-content {
  display: flex;
  gap: 40px;
  justify-content: center;
  align-items: flex-start;
}

/* Left column: inputs */
.input-section {
  flex: 1 1;
  max-width: 350px;
  background-color: #1a1a1a;
  padding: 25px 30px;
  border-radius: 8px;
  box-shadow: inset 0 0 10px #f7931a33;
  text-align: left;
}

.input-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
}

.input-group label {
  margin-bottom: 8px;
  font-weight: 600;
  color: #ffa733;
}

.input-group input,
.input-group select {
  padding: 12px 15px;
  border-radius: 6px;
  border: 1.5px solid #444;
  background-color: #1a1a1a;
  color: #f2f2f2;
  font-size: 1rem;
  transition: border-color 0.3s ease;
}

.input-group input:focus,
.input-group select:focus {
  outline: none;
  border-color: #f7931a;
}

.error-text {
  margin-top: 6px;
  color: #ff6b6b;
  font-weight: 600;
  font-size: 0.9rem;
}

.button-group {
  margin-bottom: 10px;
  text-align: center;
}

.start-button,
.stop-button {
  padding: 14px 40px;
  font-weight: bold;
  border-radius: 10px;
  font-size: 1.1rem;
  cursor: pointer;
  border: none;
  box-shadow: 0 4px 15px rgba(247, 147, 26, 0.4);
  transition: all 0.3s ease;
  width: 100%;
}

.start-button {
  background-color: #f7931a;
  color: #000;
}

.start-button:disabled {
  background-color: #6b6b6b;
  cursor: not-allowed;
  box-shadow: none;
}

.start-button:hover:not(:disabled) {
  background-color: #ffa733;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(247, 147, 26, 0.6);
}

.stop-button {
  background-color: #ff3b3b;
  color: #fff;
}

.stop-button:hover {
  background-color: #ff5656;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 59, 59, 0.7);
}

/* Right column: stats only */
.right-column {
  flex: 1.4 1;
  background-color: #1a1a1a;
  padding: 25px 30px;
  border-radius: 8px;
  box-shadow: inset 0 0 10px #f7931a33;
  display: flex;
  flex-direction: column;
  gap: 25px;
  text-align: left;
}

/* Hide old mining log section inside right-column */
.right-column .log-section {
  display: none;
}

.status-message {
  padding: 15px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 1rem;
  text-align: center;
  max-width: 100%;
}

.status-message.success {
  background-color: #3a6600;
  color: #d1f7a3;
}

.status-message.error {
  background-color: #a62a2a;
  color: #f7a3a3;
}

.status-message.info {
  background-color: #444444;
  color: #ccc;
}

.stats-section h3 {
  color: #f7931a;
  margin-bottom: 15px;
  font-weight: 600;
  text-align: center;
}

.stats-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.stats-list li {
  padding: 8px 0;
  font-size: 1.1rem;
  border-bottom: 1px solid #333;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* New full-width mining log container below the two columns */
.mining-log-fullwidth {
  max-width: 900px;
  margin: 40px auto 0;
  background-color: #1a1a1a;
  padding: 25px 30px;
  border-radius: 8px;
  box-shadow: inset 0 0 10px #f7931a33;
  text-align: left;
}

.mining-log-fullwidth h3 {
  color: #f7931a;
  margin-bottom: 15px;
  font-weight: 600;
  text-align: center;
}

.mining-log-fullwidth .log-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mining-log-fullwidth .log-list li {
  padding: 8px 0;
  font-size: 1.1rem;
  border-bottom: 1px solid #333;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: monospace;
}

.mining-log-fullwidth .log-time {
  color: #ccc;
  font-weight: 600;
}

.mining-log-fullwidth .log-hashrate {
  color: #f7931a;
  font-weight: 700;
}

/* Responsive */
@media (max-width: 768px) {
  .dashboard-content {
    flex-direction: column;
  }

  .input-section,
  .right-column {
    max-width: 100%;
    box-shadow: inset 0 0 10px #f7931a33;
    margin-bottom: 20px;
  }

  .start-button,
  .stop-button {
    width: 100%;
  }

  .mining-log-fullwidth {
    max-width: 100%;
    margin: 20px 0 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/css/StartMining.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,4DAA4D;EAC5D,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,8CAA8C;EAC9C,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,6BAA6B;AAC7B;EACE,WAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,eAAe;IACf,oCAAoC;IACpC,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".start-mining {\n  max-width: 900px;\n  margin: 60px auto 100px;\n  padding: 40px 30px;\n  background-color: #0d0d0d;\n  color: #f2f2f2;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  line-height: 1.6;\n  font-size: 1.1rem;\n  box-shadow: 0 4px 15px rgba(247, 147, 26, 0.8);\n  border-radius: 8px;\n  text-align: center;\n}\n\n.start-mining h2 {\n  color: #f7931a;\n  margin-bottom: 30px;\n  font-weight: 600;\n}\n\n.dashboard-content {\n  display: flex;\n  gap: 40px;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n/* Left column: inputs */\n.input-section {\n  flex: 1;\n  max-width: 350px;\n  background-color: #1a1a1a;\n  padding: 25px 30px;\n  border-radius: 8px;\n  box-shadow: inset 0 0 10px #f7931a33;\n  text-align: left;\n}\n\n.input-group {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 25px;\n}\n\n.input-group label {\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #ffa733;\n}\n\n.input-group input,\n.input-group select {\n  padding: 12px 15px;\n  border-radius: 6px;\n  border: 1.5px solid #444;\n  background-color: #1a1a1a;\n  color: #f2f2f2;\n  font-size: 1rem;\n  transition: border-color 0.3s ease;\n}\n\n.input-group input:focus,\n.input-group select:focus {\n  outline: none;\n  border-color: #f7931a;\n}\n\n.error-text {\n  margin-top: 6px;\n  color: #ff6b6b;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.button-group {\n  margin-bottom: 10px;\n  text-align: center;\n}\n\n.start-button,\n.stop-button {\n  padding: 14px 40px;\n  font-weight: bold;\n  border-radius: 10px;\n  font-size: 1.1rem;\n  cursor: pointer;\n  border: none;\n  box-shadow: 0 4px 15px rgba(247, 147, 26, 0.4);\n  transition: all 0.3s ease;\n  width: 100%;\n}\n\n.start-button {\n  background-color: #f7931a;\n  color: #000;\n}\n\n.start-button:disabled {\n  background-color: #6b6b6b;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.start-button:hover:not(:disabled) {\n  background-color: #ffa733;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(247, 147, 26, 0.6);\n}\n\n.stop-button {\n  background-color: #ff3b3b;\n  color: #fff;\n}\n\n.stop-button:hover {\n  background-color: #ff5656;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(255, 59, 59, 0.7);\n}\n\n/* Right column: stats only */\n.right-column {\n  flex: 1.4;\n  background-color: #1a1a1a;\n  padding: 25px 30px;\n  border-radius: 8px;\n  box-shadow: inset 0 0 10px #f7931a33;\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n  text-align: left;\n}\n\n/* Hide old mining log section inside right-column */\n.right-column .log-section {\n  display: none;\n}\n\n.status-message {\n  padding: 15px;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 1rem;\n  text-align: center;\n  max-width: 100%;\n}\n\n.status-message.success {\n  background-color: #3a6600;\n  color: #d1f7a3;\n}\n\n.status-message.error {\n  background-color: #a62a2a;\n  color: #f7a3a3;\n}\n\n.status-message.info {\n  background-color: #444444;\n  color: #ccc;\n}\n\n.stats-section h3 {\n  color: #f7931a;\n  margin-bottom: 15px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.stats-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.stats-list li {\n  padding: 8px 0;\n  font-size: 1.1rem;\n  border-bottom: 1px solid #333;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n/* New full-width mining log container below the two columns */\n.mining-log-fullwidth {\n  max-width: 900px;\n  margin: 40px auto 0;\n  background-color: #1a1a1a;\n  padding: 25px 30px;\n  border-radius: 8px;\n  box-shadow: inset 0 0 10px #f7931a33;\n  text-align: left;\n}\n\n.mining-log-fullwidth h3 {\n  color: #f7931a;\n  margin-bottom: 15px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.mining-log-fullwidth .log-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.mining-log-fullwidth .log-list li {\n  padding: 8px 0;\n  font-size: 1.1rem;\n  border-bottom: 1px solid #333;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-family: monospace;\n}\n\n.mining-log-fullwidth .log-time {\n  color: #ccc;\n  font-weight: 600;\n}\n\n.mining-log-fullwidth .log-hashrate {\n  color: #f7931a;\n  font-weight: 700;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .dashboard-content {\n    flex-direction: column;\n  }\n\n  .input-section,\n  .right-column {\n    max-width: 100%;\n    box-shadow: inset 0 0 10px #f7931a33;\n    margin-bottom: 20px;\n  }\n\n  .start-button,\n  .stop-button {\n    width: 100%;\n  }\n\n  .mining-log-fullwidth {\n    max-width: 100%;\n    margin: 20px 0 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
